import { useRouter } from 'next/router';
import { useState } from 'react';
import { useTheme } from 'styled-components';

import Autosuggest from '~components/Autosuggest';
import Search from '~components/Icon/Search';
import { ICompany } from '~types/company';
import { setGtmDataLayer } from '~utils/common/thirdPartyEvent';

import * as S from './style';

export default function SearchBar() {
  const theme = useTheme();
  const router = useRouter();
  const [value, setValue] = useState<ICompany>({
    PK_NM_HASH: '',
    location: '',
    locationCode: '',
    name: '',
  });

  return (
    <S.Wrapper>
      <S.IconWrapper>
        <Search width={17} height={17} color={theme.colors.magenta700} />
      </S.IconWrapper>

      <Autosuggest
        value={value}
        renderInput={
          <S.Input
            placeholder='기업을 입력해 보세요.'
            data-attribute-id='gnb'
            data-gnb-kind='search'
          />
        }
        setValue={(company) => setValue(company)}
        inlineCss={S.inlineCss}
        listCss={S.listCss}
        isForm
        handleChange={(value: ICompany) => {
          router.push(`/company/${value.PK_NM_HASH}`);
          setGtmDataLayer('search__enter', {
            searchValue: value.name,
          });
        }}
        onSubmit={(data, search) => {
          router.push(`/company/${data.PK_NM_HASH}`);
          setGtmDataLayer('search__enter', {
            searchValue: search,
          });
        }}
      />
    </S.Wrapper>
  );
}
